import {
  FaIdCard,
  FaRulerCombined,
  FaUsers,
  FaTicketAlt,
  FaLock,
  FaFingerprint,
  FaAlignLeft,
  FaFlask,
  FaCreditCard,
  FaFont,
  FaPalette,
  FaQrcode,
  FaAddressCard,
  FaWifi,
  FaBirthdayCake,
  FaChartLine,
  FaExchangeAlt,
  FaCompass,
  FaCoins,
  FaFileContract,
  FaGift,
  FaImage,
  FaBomb,
  FaCode,
  FaSearch,
  FaDatabase,
  FaHistory,
  FaColumns,
  FaAdjust,
  FaMoneyBillWave,
  FaHome,
  FaFileAlt,
  FaPaintBrush,
  FaLink,
  FaCheckCircle,
  FaClock,
  FaHashtag,
  FaFileCode,
  FaShieldAlt,
  FaStar,
  FaReceipt,
  FaTags,
  FaComment,
  FaShoppingCart,
  FaStopwatch,
  FaDice,
  FaFileExport,
  FaMagic,
  FaCalculator,
  FaThumbtack,
  FaSatelliteDish,
  FaChessBoard,
  FaPoll,
  FaStickyNote,
  FaTrophy,
  FaExclamationTriangle,
  FaCloudUploadAlt,
} from 'react-icons/fa'

export const CATEGORIES = [
  { key: 'geradores', label: 'Geradores', icon: FaMagic },
  { key: 'conversores', label: 'Conversores', icon: FaExchangeAlt },
  { key: 'sorteios', label: 'Sorteios e Decisão', icon: FaDice },
  { key: 'calculadoras', label: 'Calculadoras', icon: FaCalculator },
  { key: 'financeiro', label: 'Financeiro', icon: FaMoneyBillWave },
  { key: 'dev', label: 'Dev e Dados', icon: FaCode },
  { key: 'seguranca', label: 'Segurança e Privacidade', icon: FaShieldAlt },
  { key: 'produtividade', label: 'Produtividade', icon: FaThumbtack },
]

export const TOOLS = [
  {
    to: '/ferramentas/gerador-cpf-cnpj',
    title: 'Gerador de CPF e CNPJ',
    description:
      'Números válidos (dígito verificador correto) para testar formulários e sistemas.',
    icon: FaIdCard,
    category: 'geradores',
  },
  {
    to: '/ferramentas/conversor-unidades',
    title: 'Conversor de Unidades',
    description: 'Comprimento, peso e temperatura: km/milhas, kg/lb, °C/°F.',
    icon: FaRulerCombined,
    category: 'conversores',
  },
  {
    to: '/ferramentas/sorteio-de-nomes',
    title: 'Sorteio de Nomes',
    description: 'Amigo secreto, rifas e sorteios: cole a lista e sorteie.',
    icon: FaUsers,
    category: 'sorteios',
  },
  {
    to: '/ferramentas/gerador-de-bingo',
    title: 'Cartela de Bingo Digital',
    description:
      'Cartelas únicas prontas para imprimir, no estilo B-I-N-G-O.',
    icon: FaTicketAlt,
    category: 'sorteios',
  },
  {
    to: '/ferramentas/gerador-de-senha',
    title: 'Gerador de Senha Forte',
    description: 'Senhas aleatórias e seguras, do jeito que você quiser.',
    icon: FaLock,
    category: 'geradores',
  },
  {
    to: '/ferramentas/gerador-uuid',
    title: 'Gerador de UUID',
    description: 'UUIDs v4 aleatórios, um ou vários de uma vez.',
    icon: FaFingerprint,
    category: 'geradores',
  },
  {
    to: '/ferramentas/lorem-ipsum',
    title: 'Gerador de Lorem Ipsum',
    description: 'Texto de preenchimento em português, pra maquetes.',
    icon: FaAlignLeft,
    category: 'geradores',
  },
  {
    to: '/ferramentas/gerador-dados-fake',
    title: 'Gerador de Dados Fake',
    description: 'Pessoas fictícias com nome, e-mail, telefone e endereço.',
    icon: FaFlask,
    category: 'geradores',
  },
  {
    to: '/ferramentas/gerador-cartao-teste',
    title: 'Gerador de Cartão de Teste',
    description: 'Números fictícios válidos por Luhn, pra testar pagamentos.',
    icon: FaCreditCard,
    category: 'geradores',
  },
  {
    to: '/ferramentas/codificador-base64-url',
    title: 'Codificador Base64 / URL',
    description: 'Codifique e decodifique texto instantaneamente.',
    icon: FaFont,
    category: 'dev',
  },
  {
    to: '/ferramentas/conversor-de-cores',
    title: 'Conversor de Cores',
    description: 'HEX, RGB e HSL, com prévia visual ao vivo.',
    icon: FaPalette,
    category: 'conversores',
  },
  {
    to: '/ferramentas/gerador-qrcode',
    title: 'Gerador de QR Code',
    description: 'Qualquer texto ou link vira QR Code na hora.',
    icon: FaQrcode,
    category: 'geradores',
  },
  {
    to: '/ferramentas/cartao-visita-digital',
    title: 'Cartão de Visita Digital',
    description: 'QR Code que salva seus contatos direto na agenda.',
    icon: FaAddressCard,
    category: 'geradores',
  },
  {
    to: '/ferramentas/qrcode-wifi',
    title: 'QR Code de Wi-Fi',
    description: 'Conecte ao Wi-Fi escaneando, sem digitar a senha.',
    icon: FaWifi,
    category: 'geradores',
  },
  {
    to: '/ferramentas/calculadora-de-idade',
    title: 'Calculadora de Idade',
    description: 'Idade exata em anos, meses e dias.',
    icon: FaBirthdayCake,
    category: 'calculadoras',
  },
  {
    to: '/ferramentas/calculadora-juros-compostos',
    title: 'Calculadora de Juros Compostos',
    description: 'Simule investimentos com aportes mensais.',
    icon: FaChartLine,
    category: 'financeiro',
  },
  {
    to: '/ferramentas/roleta-de-decisao',
    title: 'Roleta de Decisão',
    description: 'Não sabe o que decidir? Gire a roleta.',
    icon: FaCompass,
    category: 'sorteios',
  },
  {
    to: '/ferramentas/cara-ou-coroa-dado',
    title: 'Cara ou Coroa e Dado',
    description: 'Sorteios rápidos: moeda ou dado virtual.',
    icon: FaCoins,
    category: 'sorteios',
  },
  {
    to: '/ferramentas/calculadora-rescisao-clt',
    title: 'Calculadora de Rescisão CLT',
    description: 'Estimativa de aviso prévio, férias, 13º e multa FGTS.',
    icon: FaFileContract,
    category: 'financeiro',
  },
  {
    to: '/ferramentas/amigo-secreto',
    title: 'Amigo Secreto com Link',
    description: 'Sorteia e gera um link individual pra cada pessoa.',
    icon: FaGift,
    category: 'sorteios',
  },
  {
    to: '/ferramentas/compressor-de-imagem',
    title: 'Compressor de Imagem',
    description: 'Reduza o tamanho de fotos sem sair do navegador.',
    icon: FaImage,
    category: 'seguranca',
  },
  {
    to: '/ferramentas/texto-temporario',
    title: 'Texto Temporário (lido 1x)',
    description:
      'Envie um texto secreto que se autodestrói depois de ser lido uma vez.',
    icon: FaBomb,
    category: 'seguranca',
  },
  {
    to: '/ferramentas/formatador-json',
    title: 'Formatador e Validador de JSON',
    description:
      'Árvore expansível, aponta erro de sintaxe com linha e coluna, exporta pra YAML.',
    icon: FaCode,
    category: 'dev',
  },
  {
    to: '/ferramentas/testador-regex',
    title: 'Testador de Regex',
    description: 'Destaca matches e grupos de captura ao vivo, enquanto você digita.',
    icon: FaSearch,
    category: 'dev',
  },
  {
    to: '/ferramentas/gerador-mock-api',
    title: 'Gerador de Mock de API',
    description: 'Monte os campos e gere um array de dados fake no formato de API.',
    icon: FaDatabase,
    category: 'dev',
  },
  {
    to: '/ferramentas/explicador-cron',
    title: 'Explicador de Expressão Cron',
    description: 'Entenda o que uma expressão cron faz e veja as próximas execuções.',
    icon: FaHistory,
    category: 'dev',
  },
  {
    to: '/ferramentas/comparador-de-texto',
    title: 'Comparador de Texto (Diff)',
    description: 'Compare dois textos e veja o que foi adicionado ou removido, linha a linha.',
    icon: FaColumns,
    category: 'dev',
  },
  {
    to: '/ferramentas/verificador-contraste',
    title: 'Verificador de Contraste WCAG',
    description: 'Confira se duas cores têm contraste suficiente pelas regras AA e AAA.',
    icon: FaAdjust,
    category: 'dev',
  },
  {
    to: '/ferramentas/calculadora-salario-liquido',
    title: 'Calculadora de Salário Líquido CLT',
    description: 'Salário bruto até o líquido, com desconto de INSS e IRRF pelas tabelas atuais.',
    icon: FaMoneyBillWave,
    category: 'financeiro',
  },
  {
    to: '/ferramentas/simulador-financiamento',
    title: 'Simulador de Financiamento Price vs SAC',
    description: 'Compare as duas tabelas com amortização mês a mês completa.',
    icon: FaHome,
    category: 'financeiro',
  },
  {
    to: '/ferramentas/gerador-curriculo',
    title: 'Gerador de Currículo Online',
    description: 'Monte seu currículo com prévia ao vivo e exporte em PDF.',
    icon: FaFileAlt,
    category: 'geradores',
  },
  {
    to: '/ferramentas/paleta-de-cores',
    title: 'Gerador de Paleta de Cores',
    description: 'Paletas complementares, análogas, tríade ou tétrade, exportadas como CSS.',
    icon: FaPaintBrush,
    category: 'geradores',
  },
  {
    to: '/ferramentas/encurtador-url',
    title: 'Encurtador de URL',
    description: 'Transforme um link longo em um link curto jarder.dev/s/xxxxxx.',
    icon: FaLink,
    category: 'dev',
  },
  {
    to: '/ferramentas/validador-cpf-cnpj',
    title: 'Validador de CPF e CNPJ',
    description: 'Digite um número e confira se os dígitos verificadores são válidos.',
    icon: FaCheckCircle,
    category: 'seguranca',
  },
  {
    to: '/ferramentas/conversor-unix-timestamp',
    title: 'Conversor de Unix Timestamp',
    description: 'Epoch para data legível e vice-versa.',
    icon: FaClock,
    category: 'conversores',
  },
  {
    to: '/ferramentas/gerador-de-hash',
    title: 'Gerador de Hash',
    description: 'MD5, SHA-1 e SHA-256 de qualquer texto, direto no navegador.',
    icon: FaHashtag,
    category: 'dev',
  },
  {
    to: '/ferramentas/gerador-gitignore',
    title: 'Gerador de .gitignore',
    description: 'Escolha linguagens e frameworks e monte o arquivo combinado.',
    icon: FaFileCode,
    category: 'dev',
  },
  {
    to: '/ferramentas/verificador-forca-senha',
    title: 'Verificador de Força de Senha',
    description: 'Avalie uma senha digitada e receba dicas pra deixá-la mais segura.',
    icon: FaShieldAlt,
    category: 'seguranca',
  },
  {
    to: '/ferramentas/numeros-da-sorte',
    title: 'Gerador de Números da Sorte',
    description: 'Jogos aleatórios de Mega-Sena, Lotofácil, Quina e Lotomania.',
    icon: FaStar,
    category: 'sorteios',
  },
  {
    to: '/ferramentas/simulador-parcelamento-cartao',
    title: 'Simulador de Parcelamento no Cartão',
    description: 'Valor, parcelas e juros: veja o total que você vai pagar.',
    icon: FaReceipt,
    category: 'financeiro',
  },
  {
    to: '/ferramentas/calculadora-precificacao',
    title: 'Calculadora de Precificação e Margem',
    description: 'Custo e margem de lucro desejada até o preço de venda ideal.',
    icon: FaTags,
    category: 'financeiro',
  },
  {
    to: '/ferramentas/contador-de-caracteres',
    title: 'Contador de Caracteres para Redes Sociais',
    description: 'Compare seu texto com os limites de X, Instagram, LinkedIn e mais.',
    icon: FaComment,
    category: 'dev',
  },
  {
    to: '/ferramentas/lista-de-compras',
    title: 'Lista de Compras Compartilhável',
    description: 'Crie uma lista, gere um link e marque os itens junto com quem for com você, em tempo real.',
    icon: FaShoppingCart,
    category: 'produtividade',
  },
  {
    to: '/ferramentas/timer-de-foco',
    title: 'Cronômetro Pomodoro',
    description: 'Ciclos de foco e pausa configuráveis, com aviso sonoro no fim de cada etapa.',
    icon: FaStopwatch,
    category: 'produtividade',
  },
  {
    to: '/ferramentas/sorteador-de-numeros',
    title: 'Sorteador de Números',
    description: 'Escolha o intervalo, veja a contagem regressiva e descubra o número sorteado.',
    icon: FaDice,
    category: 'sorteios',
  },
  {
    to: '/ferramentas/conversor-de-arquivos',
    title: 'Conversor de Arquivos',
    description: 'Imagens (PNG/JPG/WebP), dados (CSV/JSON/XML/XLSX) e imagens para PDF, tudo no navegador.',
    icon: FaFileExport,
    category: 'conversores',
  },
  {
    to: '/ferramentas/bingo-ao-vivo',
    title: 'Bingo ao Vivo em Sala',
    description: 'Sorteie os números como mestre; cada participante entra pelo link e recebe a cartela automaticamente.',
    icon: FaChessBoard,
    category: 'sorteios',
  },
  {
    to: '/ferramentas/webhook-tester',
    title: 'Webhook Tester / Request Bin',
    description: 'Gera uma URL única e mostra ao vivo qualquer requisição HTTP que chegar nela.',
    icon: FaSatelliteDish,
    category: 'dev',
  },
  {
    to: '/ferramentas/planning-poker',
    title: 'Planning Poker',
    description: 'Sala de votação em grupo: todo mundo vota em segredo e os votos são revelados juntos.',
    icon: FaPoll,
    category: 'sorteios',
  },
  {
    to: '/ferramentas/retro-ao-vivo',
    title: 'Retro de Equipe ao Vivo',
    description: 'Quadro com bom/ruim/melhorar: cada um posta um cartão anônimo e a lista cresce ao vivo.',
    icon: FaStickyNote,
    category: 'produtividade',
  },
  {
    to: '/ferramentas/campeonato-ao-vivo',
    title: 'Chaveamento e Campeonato ao Vivo',
    description: 'Cadastre os times e acompanhe pontos corridos ou mata-mata ao vivo, com classificação e chaveamento automáticos.',
    icon: FaTrophy,
    category: 'sorteios',
  },
  {
    to: '/ferramentas/verificador-link-suspeito',
    title: 'Verificador de Link Suspeito',
    description: 'Cole um link recebido por SMS/WhatsApp e confira reputação, idade do domínio e certificado de segurança.',
    icon: FaExclamationTriangle,
    category: 'seguranca',
  },
  {
    to: '/ferramentas/compartilhar-arquivo',
    title: 'Compartilhamento de Arquivo Temporário',
    description: 'Envie um arquivo grande e receba um link que expira sozinho depois de N downloads ou X horas.',
    icon: FaCloudUploadAlt,
    category: 'produtividade',
  },
]
